import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LandingNav } from '@/components/landing/LandingNav';
import { CompaniesHero } from '@/components/landing/CompaniesHero';
import { CategoryExplainer } from '@/components/landing/CategoryExplainer';
import { Features } from '@/components/landing/Features';
import { HowItWorks } from '@/components/landing/HowItWorks';
import { Stats } from '@/components/landing/Stats';
import { WhyChooseUs } from '@/components/landing/WhyChooseUs';
import { ServiceAreas } from '@/components/landing/ServiceAreas';
import { Testimonials } from '@/components/landing/Testimonials';
import { Faq, FAQ_ITEMS } from '@/components/landing/Faq';
import { Contact } from '@/components/landing/Contact';
import { Footer } from '@/components/landing/Footer';
import { SeoFooter } from '@/components/landing/SeoFooter';
import { SEO } from '@/components/landing/SEO';
import { BRAND, IMAGES } from '@/components/landing/config';
export default function CompaniesPage() {
    const title = `رزرو غذای شرکتی، سازمانی و کارمندی آنلاین | سامانه آرشه`;
    const description = 'سامانه رزرو غذای شرکتی، سازمانی، کارمندی، پرسنلی و اداری آرشه — رزرو آنلاین وعده ناهار توسط هر کارمند، منوی روزانه، پنل مدیریت شرکت، فاکتور رسمی. تحویل به سراسر تهران از سهروردی شمالی.';
    return (_jsxs("div", { className: "bg-white dark:bg-gray-950", children: [_jsx(SEO, { title: title, description: description, path: "/companies", image: IMAGES.heroBg, keywords: [
                    // primary commercial intent (high competition, high value)
                    'رزرو غذای شرکتی',
                    'رزرو غذای کارمندی',
                    'رزرو غذای سازمانی',
                    'رزرو غذای پرسنلی',
                    'رزرو غذای اداری',
                    'سامانه رزرو غذای شرکتی',
                    'سامانه رزرو غذا',
                    'سفارش غذای شرکتی',
                    'سفارش غذای سازمانی',
                    // service/category
                    'غذای شرکتی',
                    'غذای سازمانی',
                    'غذای پرسنلی',
                    'غذای اداری',
                    'غذای کارمندی',
                    'کیترینگ شرکتی',
                    'کیترینگ سازمانی',
                    'تهیه غذای اداری',
                    'تهیه غذای شرکتی',
                    // localization
                    'غذای شرکتی تهران',
                    'کیترینگ تهران',
                    // brand
                    'رستوران آرشه',
                    'آرشه',
                ], breadcrumbs: [
                    { name: 'صفحه اصلی', path: '/' },
                    { name: 'برای شرکت‌ها', path: '/companies' },
                ], schemas: [
                    {
                        '@context': 'https://schema.org',
                        '@type': 'Service',
                        '@id': `${BRAND.url}/companies#service`,
                        serviceType: 'Corporate food service / Employee meals / Online food reservation',
                        name: 'سامانه رزرو غذای کارمندی آرشه',
                        alternateName: ['رزرو غذای کارمندی', 'سامانه رزرو غذا', 'غذای کارمندی آنلاین'],
                        description,
                        provider: {
                            '@type': ['Restaurant', 'LocalBusiness'],
                            '@id': `${BRAND.url}#restaurant`,
                            name: BRAND.name,
                            alternateName: ['رستوران آرشه', 'آرشه رستوران', 'کافه آرشه', 'آرشه', BRAND.nameEn],
                            url: BRAND.url,
                            telephone: BRAND.phone,
                            email: BRAND.email,
                            address: {
                                '@type': 'PostalAddress',
                                streetAddress: BRAND.address,
                                addressLocality: BRAND.city,
                                addressRegion: BRAND.region,
                                postalCode: BRAND.postalCode,
                                addressCountry: BRAND.country,
                            },
                        },
                        areaServed: { '@type': 'City', name: BRAND.city },
                        audience: { '@type': 'BusinessAudience', name: 'Companies and Organizations' },
                        offers: {
                            '@type': 'AggregateOffer',
                            priceCurrency: 'IRR',
                            availability: 'https://schema.org/InStock',
                        },
                    },
                    {
                        '@context': 'https://schema.org',
                        '@type': 'WebApplication',
                        name: 'سامانه رزرو غذای کارمندی آرشه',
                        url: `${BRAND.url}/companies`,
                        applicationCategory: 'BusinessApplication',
                        operatingSystem: 'Web',
                        description: 'پنل آنلاین رزرو وعده ناهار توسط هر کارمند، با گزارش‌گیری مالی و فاکتور برای مدیر شرکت.',
                        offers: { '@type': 'Offer', priceCurrency: 'IRR' },
                    },
                    {
                        '@context': 'https://schema.org',
                        '@type': 'FAQPage',
                        mainEntity: FAQ_ITEMS.map((it) => ({
                            '@type': 'Question',
                            name: it.q,
                            acceptedAnswer: { '@type': 'Answer', text: it.a },
                        })),
                    },
                ] }), _jsx(LandingNav, { variant: "companies" }), _jsxs("main", { children: [_jsx(CompaniesHero, {}), _jsx(CategoryExplainer, {}), _jsx(Features, {}), _jsx(HowItWorks, {}), _jsx(Stats, {}), _jsx(WhyChooseUs, {}), _jsx(ServiceAreas, {}), _jsx(Testimonials, {}), _jsx(Faq, {}), _jsx(Contact, {})] }), _jsx(SeoFooter, {}), _jsx(Footer, {})] }));
}
